import { Dispatch } from 'redux';
import { TGetRootState, TDispatchResult } from 'types/shared';

import {
  saveUserSettings,
  IUserSettingsState,
  IUserSettingsAction,
} from '../userSettings';

export const SET_OPUS_ACCESS_BANNER =
  'opus/user/opusAccessBanner/SET_OPUS_ACCESS_BANNER';

export default function reducer(
  state: IUserSettingsState,
  action: IUserSettingsAction
): IUserSettingsState {
  switch (action.type) {
    case SET_OPUS_ACCESS_BANNER: {
      return action?.payload;
    }
    default:
      return state;
  }
}

export const setOpusAccessBannerView = (
  opusAccessFooterBanner: boolean
): TDispatchResult<any> => {
  return function (dispatch: Dispatch, getState: TGetRootState): any {
    dispatch({
      type: SET_OPUS_ACCESS_BANNER,
      payload: opusAccessFooterBanner,
    });

    // If getState().userSettings.success.all is false, this means we encountered an error while loading the
    // userSettings endpoint. It's safest not to overwrite this with the current Redux store anymore.
    if (getState().userSettings.success.all) {
      return dispatch(saveUserSettings('opusAccessFooterBanner') as any);
    }
    // eslint-disable-next-line no-console
    console.warn(
      'We are not saving a parameter opusAccessFooterBanner to the KV store because we could not retrieve them and do not want to run the risk of corrupting data.'
    );
  };
};
